import React from 'react';
import './LocationMap.css'; // CSS pour la localisation

// Les bonnes informations
const shopAddress = "14 Place Gambetta, 32600 L'Isle-Jourdain";
const shopPhoneNumber = "05 62 63 19 60";

// Le code iframe Google Maps mis à jour
const googleMapsEmbed = `
<iframe 
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2888.63700305772!2d1.0802171119247972!3d43.614099154838094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a94f33fba9e409%3A0xb691e333ef60d2c5!2sFROMAGERIE%20CHEZ%20PAUL!5e0!3m2!1sfr!2sfr!4v1751960657836!5m2!1sfr!2sfr"
  width="600"
  height="450"
  style="border:0;"
  allowfullscreen=""
  loading="lazy"
  referrerpolicy="no-referrer-when-downgrade">
</iframe>
`;

function LocationMap() {
  // Encodage de l'adresse pour l'URL de Google Maps
  const encodedAddress = encodeURIComponent(shopAddress);

  return (
    <div className="location-map-container">
      <h3 className="location-title">Où nous trouver ?</h3>
      <div className="address-container">
        <p className="address-text">
          <strong>Fromagerie Chez Paul</strong><br />
          {shopAddress}<br />
          Téléphone : <a href={`tel:${shopPhoneNumber.replace(/\s/g, '')}`}>{shopPhoneNumber}</a>
        </p>
        {/* Lien vers Google Maps avec l'adresse encodée */}
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`}
          target="_blank"
          rel="noopener noreferrer"
          className="map-link-button"
        >
          Voir sur Google Maps
        </a>
      </div>

      {/* Conteneur pour la carte Google Maps intégrée */}
      <div
        className="map-embed-container"
        // dangerouslySetInnerHTML est utilisé ici pour insérer le code HTML de l'iframe
        // C'est acceptable car on contrôle le code qu'on y met (venant de Google Maps)
        dangerouslySetInnerHTML={{ __html: googleMapsEmbed }}
      />
    </div>
  );
}

export default LocationMap;